import { render, staticRenderFns } from "./TradeRepresentative.vue?vue&type=template&id=ce9ac22e&scoped=true&"
import script from "./TradeRepresentative.vue?vue&type=script&lang=js&"
export * from "./TradeRepresentative.vue?vue&type=script&lang=js&"
import style0 from "./TradeRepresentative.vue?vue&type=style&index=0&id=ce9ac22e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9ac22e",
  null
  
)

export default component.exports